import { createValidation } from '../../../utils/validation';
export const createComplaintStatusValidation = (fields) => { const validation = createValidation(fields); return { schema: validation.schema, validateData: validation.validateData, validateComplaintStatusData: validation.validateData, validateField: validation.validateField }; };
export default createComplaintStatusValidation;
